import { Button } from "../ui/button";
import { Input } from "../ui/input";
import DateInput from "../DateInput";
import { Label } from "../ui/label";
import { Dialog, DialogContent, DialogDescription, DialogHeader, DialogTitle, DialogFooter } from "../ui/dialog";
import { PosSplitFields } from "./PosSplitFields";

export const NuovaRigaDialog = ({ open, onOpenChange, form, onFormChange, metodiEntrata, banchePos, onSubmit }) => (
  <Dialog open={open} onOpenChange={onOpenChange}>
    <DialogContent className="max-w-md bg-card border-border" data-testid="new-daily-row-dialog">
      <DialogHeader>
        <DialogTitle className="text-foreground">Nuova Riga Giornaliera</DialogTitle>
        <DialogDescription className="sr-only">Inserisci le entrate giornaliere suddivise per metodo.</DialogDescription>
      </DialogHeader>
      <form onSubmit={onSubmit} className="space-y-4">
        <div className="space-y-2">
          <Label className="text-foreground/70">Data *</Label>
          <DateInput value={form.data || ""} onChange={(v) => onFormChange({ ...form, data: v })} />
        </div>
        <div className="border-t border-border pt-4 space-y-3">
          <Label className="text-sm font-medium text-foreground/70">Entrate del giorno</Label>
          <div className="grid grid-cols-1 sm:grid-cols-2 gap-3">
            {metodiEntrata.map((metodo) => (
              metodo === "POS" && banchePos.length > 0 ? (
                <div key={metodo} className="sm:col-span-2">
                  <PosSplitFields
                    banks={banchePos}
                    values={form.split_pos || {}}
                    onChange={(split_pos) => onFormChange({ ...form, split_pos })}
                    prefix="daily-entry"
                  />
                </div>
              ) : (
              <div key={metodo} className="space-y-1">
                <Label className="text-xs text-muted-foreground">{metodo}</Label>
                <Input
                  type="number"
                  step="0.01"
                  placeholder="0.00"
                  value={form[metodo] || ""}
                  onChange={(e) => onFormChange({ ...form, [metodo]: e.target.value })}
                  className="h-9 bg-card border-border text-foreground"
                  data-testid={`daily-entry-${metodo.toLowerCase().replace(/\s+/g, '-')}-input`}
                />
              </div>
              )
            ))}
          </div>
        </div>
        <DialogFooter>
          <Button type="button" variant="outline" onClick={() => onOpenChange(false)} className="border-border text-foreground hover:bg-accent hover:text-accent-foreground" data-testid="daily-entry-cancel-button">Annulla</Button>
          <Button type="submit" className="bg-lime-500 hover:bg-lime-400 text-black" data-testid="daily-entry-save-button">Salva</Button>
        </DialogFooter>
      </form>
    </DialogContent>
  </Dialog>
);
